import { useQuery, useMutation, useQueryClient } from "react-query";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

export function useInfoData(customerId) {
  const queryClient = useQueryClient();

  const query = useQuery(["customers", "info", customerId], () =>
    makeAuthedRequest(`/customers/information/${customerId}`).then(
      async (res) => {
        const json = await res.json();

        if (res.ok) {
          return json.data;
        } else {
          console.error(json);
          throw new Error("Request failed");
        }
      }
    )
  );

  const saveMutation = useMutation(
    (data) =>
      makeAuthedRequest(`/customers/information/${customerId}`, {
        method: "put",
        body: JSON.stringify(data),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["customers", "info", customerId]);
      },
    }
  );

  return {
    ...query,
    saveMutation,
  };
}
